import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mcProjectFilePickerInputItem]'
})
export class ProjectFilePickerInputItemDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}
